import { API_URL } from '../Config.js';

const apiUrl = API_URL 


const getFdoImgList = ( accessToken ) => {

    const headers = {
        Authorization: `Bearer ${accessToken}`
    }

    const url = `${apiUrl}formularios/frmGetGrillaFondosImg`

    return fetch(url, { headers })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(error => console.log('Error:', error));
};

 const addFondoImg = (data, accessToken) => {

    const url = `${apiUrl}formularios/frmInsertLogosFdo` 

    return fetch(url, { method: 'POST', body: JSON.stringify(data), headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` } })
        .then(response => { return response.json() })
            //.then(data => {return data})
        .catch(
            error => { 
                
            }); 

}

const deleteFondoImg = (data, accessToken) => {

    const url = `${apiUrl}formularios/frmDelLogosFdo` 

    return fetch(url, { method: 'POST', body: JSON.stringify(data), headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` } })
        .then(response => { 
            return;
        })
        .catch(
            error => { 
                
            }); 

}

/*

const getLeyendaPosicionList = ( accessToken ) => {

    const headers = {
        Authorization: `Bearer ${accessToken}`
    }

    const url = `${apiUrl}formularios/frmGetLeyendasPosicion`

    return fetch(url, { headers })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(error => console.log('Error:', error));
};

const addLeyendaFirma = (data, accessToken) => {

    const url = `${apiUrl}formularios/frmInsertLeyendasFirmasOc`

    return fetch(url, { method: 'POST', body: JSON.stringify(data), headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${accessToken}` } })
        .then(response => { return response.json() })
        .catch(error => { });

} */


//export { getFdoImgList, getLeyendaPosicionList, addLeyendaImg, addLeyendaFirma }
export { getFdoImgList, addFondoImg, deleteFondoImg}